import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "order-form-balance" }
const _hoisted_2 = { class: "order-form-balance__label" }
const _hoisted_3 = { class: "order-form-balance__data" }

import { computed, inject, ref, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';

import type BigNumber from '@exchange/helpers/bignumber';

interface OrderBalanceBySide {
  code: string;
  precision: number;
  available: BigNumber;
  locked: BigNumber;
  marginAvailable?: BigNumber;
}

interface FormBalance {
  id: string;
  label: string;
  value: BigNumber;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderFormBalance',
  props: {
  balance: { type: Object as PropType<OrderBalanceBySide>, default: () => {} },
  showLoading: { type: Boolean, required: true },
  isFutures: { type: Boolean, required: true },
  maxPositionSize: { type: Object as PropType<BigNumber>, required: true },
},
  setup(__props) {

const props = __props;

const { t } = useI18n({ useScope: 'global' });
const balanceMasked = inject('balanceMasked', ref(false));

const balances = computed<Array<FormBalance>>(() => [
  {
    id: 'available',
    label: t('modules.orderForm.availableBalance'),
    value: props.balance.available,
  },
  {
    id: 'locked',
    label: t('modules.orderForm.lockedBalance'),
    value: props.balance.locked,
  },
]);

const futuresBalance = computed(() => [
  {
    id: 'maxPositionSize',
    label: t('modules.orderForm.maxPositionSize'),
    value: props.maxPositionSize,
  },
]);

const code = computed(() => props.balance.code);
const precision = computed(() => props.balance.precision);

return (_ctx: any,_cache: any) => {
  const _component_ot_balance_loading = _resolveComponent("ot-balance-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.isFutures ? futuresBalance.value : balances.value, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.id,
        class: "order-form-balance__item"
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(item.label), 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_ot_balance_loading, {
            "loading-until": __props.showLoading,
            value: item.value,
            precision: precision.value,
            symbol: code.value,
            "light-symbol": false,
            masked: _unref(balanceMasked)
          }, null, 8, ["loading-until", "value", "precision", "symbol", "masked"])
        ])
      ]))
    }), 128))
  ]))
}
}

})